<template>
    <div
      v-if="nextEntityId != ''"
      class="pb-6 px-6"
      style="position: absolute; bottom: 0; right: 0;"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            data-testid="next-button"
            elevation="0"
            class="rounded-lg text-none pa-0"
            v-on="on"
            color="accent"
            min-width="36px"
            @click="nextPage()"
          >
            <v-icon size="24">
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('nextPageTooltip') }}</span>
      </v-tooltip>
    </div>
</template>
<script>

export default {
    props: {
        activityPages: {
          type: Array,
          default: () => []
        }
    },
        data(){
        return{
            activityId: this.$route.params.id,
            nextEntityType: '',
            nextEntityId: '',
        }
    },
    async created(){  
        this.loadingData = true
        await this.getNextFeedItem()
        this.loadingData = false     
    },
    methods:{
        async getNextFeedItem(){
            const thisRouteName = this.$route.name
            this.nextEntityType = ''
            this.nextEntityId = ''
            let thisEntityType = ''
            let thisEntityId = ''

            if (thisRouteName == 'ViewActivityPage') {
                thisEntityType = 'activity_page'
                thisEntityId = this.$route.params.pageId
            } else if (thisRouteName == 'ViewActivityQuiz') {
                thisEntityType = 'quiz'
                thisEntityId = this.$route.params.quizId
            }else if (thisRouteName == 'ViewActivityScorm') {
                thisEntityType = 'scorm'
                thisEntityId = this.$route.params.scormId
            }else if (thisRouteName == 'ViewActivityChecklist') {
                thisEntityType = 'checklist'
                thisEntityId = this.$route.params.checklistId
            }else if (thisRouteName == 'ViewActivitySurvey') {
                thisEntityType = 'survey'
                thisEntityId = this.$route.params.surveyId
            }
            if (this.activityPages.length > 0) {
                var saveNext = false
                for (let i = 0; i < this.activityPages.length; i++) {
                    if (this.activityPages[i].attributes.entity_type !== 'section'){
                        if(saveNext != false) {
                            this.nextEntityType = this.activityPages[i].attributes.entity_type
                            this.nextEntityId = this.activityPages[i].attributes.entity_id
                            break
                        }
                        if (this.activityPages[i].attributes.entity_type == thisEntityType && this.activityPages[i].attributes.entity_id == thisEntityId) {
                            saveNext = true
                        }
                    }
                }
            }
            
        },
        nextPage() {
            var entity = ''
            if (this.nextEntityType == 'activity_page') {
                entity = 'page'
            } else if (this.nextEntityType == 'quiz') {
                entity = 'quiz'
            }else if (this.nextEntityType == 'scorm') {
                entity = 'scorm'
            }else if (this.nextEntityType == 'checklist') {
                entity = 'checklist'
            }else if (this.nextEntityType == 'survey') {
                entity = 'survey'
            }

            if (entity) {
                this.$router.push({path: '/activity/' + this.$route.params.id + '/' + entity + '/' + this.nextEntityId})
            }
        },
    },
}
</script>